import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import GridCol from 'components/grid/grid-col';
import GridRow from 'components/grid/grid-row';
import DataModuleInfo from 'pages/body-data/_data-module-info';
import DataModuleVideo from 'pages/body-data/_data-module-video';

export default function DataModule(props) {
  return (
    <div className="tier mix-tier_borderedDarkGrayMobile">
      <div className="container">
        <GridRow className="mix-grid_vertCenter">
          <GridCol
            className="cell_separatedSm cell_separatedMd"
            phone="4"
            tablet="8"
            tabletLg="4"
            desktop="7"
          >
            <DataModuleVideo data={props.data} />
          </GridCol>
          <GridCol
            className="cell_separatedSm cell_separatedMd"
            phone="4"
            tablet="8"
            tabletLg="4"
            desktop="5"
          >
            <DataModuleInfo data={props.data} />
          </GridCol>
        </GridRow>
      </div>
    </div>
  );
}

DataModule.propTypes = {
  'data': PropTypes.object
};



// WEBPACK FOOTER //
// ./src/client/pages/body-data/_data-module.jsx